// ============================================================================
// GLOBAL SELLING PLAN ID
// ============================================================================
const GLOBAL_SELLING_PLAN_ID = 692322074972;

// ============================================================================
// PRODUCT VARIANT MAPPING
// ============================================================================
window.PRODUCT_VARIANTS = {
    'hausverwaltung-essential': '56722127389020',
    'hausverwaltung-plus': '56722129224028',
    'hausverwaltung-pro': '56722130207068',
    'restaurant-essential': '56701024895324',
    'restaurant-plus': '57277169402204',
    'restaurant-pro': '56722083414364',
    'ecommerce-essential': '56722124767580',
    'ecommerce-plus': '56722125455708',
    'ecommerce-pro': '56722126373212',
    'pflegeheim-essential': '56722119164252',
    'pflegeheim-plus': '56722120966492',
    'pflegeheim-pro': '56722124177756'
};

// ============================================================================
// ADD TO CART - SUBSCRIPTION-SAFE
// ============================================================================
window.addToCart = function(variantId, isSubscription = false) {
    if (!variantId || isNaN(Number(variantId))) {
        console.error('[Cart] Invalid variantId:', variantId);
        alert('Ungültige Produkt-ID');
        return Promise.reject(new Error('Invalid variantId'));
    }

    const item = {
        id: Number(variantId),
        quantity: 1
    };

    if (isSubscription) {
        item.selling_plan = GLOBAL_SELLING_PLAN_ID;
    }


    return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
    })
    .then(res => {
        if (!res.ok) {
            return res.json().then(err => {
                console.error('[Cart] API Error:', err);
                throw new Error(err.description || 'Add to cart failed');
            });
        }
        return res.json();
    })
    .then(data => {
        window.location.href = '/cart';
        return data;
    })
    .catch(err => {
        console.error('[Cart] Error:', err);
        alert('Fehler beim Hinzufügen zum Warenkorb: ' + err.message);
        throw err;
    });
};

// ============================================================================
// KONFIGURATOR HELPER
// ============================================================================
window.addProductToCart = function(industry, abo) {
    const key = String(industry).toLowerCase() + '-' + String(abo).toLowerCase();
    const variantId = window.PRODUCT_VARIANTS[key];

    if (!variantId) {
        console.error('[Cart] Product not found:', key);
        alert('Produkt nicht gefunden: ' + key);
        return Promise.reject(new Error('Product not found'));
    }

    return window.addToCart(variantId, true);
};

